import Header from "../general/Header";
import MainTitle from "./MainTitle";
import SingleCollection from "./SingleCollection";
import Footer from "./Footer";
import { useShopifyCollectionsControllerGetCollectionsWithProducts } from "../../services/generated";
import { styled } from "@mui/material";

const PageWrapper = styled("div")({
  minHeight: "100vh",
  width: "100%",
  overflowX: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const CollectionsWrapper = styled("div")({
  width: "100%",
  minHeight: "100vh",
});

const Home = () => {
  const { data } = useShopifyCollectionsControllerGetCollectionsWithProducts();

  const collections = data?.data;

  return (
    <PageWrapper>
      <Header />
      <MainTitle />

      <CollectionsWrapper>
        {collections?.map((collection) => (
          <SingleCollection
            key={collection.id}
            collectionId={collection.id}
            collectionName={collection.title}
            mainPhotoUrl={collection.image}
            products={collection.products}
          />
        ))}
      </CollectionsWrapper>
      <Footer />
    </PageWrapper>
  );
};

export default Home;
